module.exports = __webpack_public_path__ + "img/laboratory-2815641.cf25dc67.jpg";